import axios from './axios';

// api end point
const endpoints = {
  profile: '/api/profile'
};

/**
 * Get the user profile
 *
 * @description  This function will be called when the <App/> is mounted.
 *               If the response return 200, the app will recognize it
 *               as authenticated (using cookies to pass login process),
 *               even the user doesn't login through the Auth0 service.
 *
 * @param accessToken {string} user access token
 * @return {Promise<AxiosResponse<T>|*>}
 *
 * https://github.com/axios/axios#response-schema
 *
 * axios response object
 *
 * {
     // `data` is the response that was provided by the server
     data: {},

     // `status` is the HTTP status code from the server response
     status: 200,

     // `statusText` is the HTTP status message from the server response
     statusText: 'OK',

     // `headers` the headers that the server responded with
     // All header names are lower cased
     headers: {},

     // `config` is the config that was provided to `axios` for the request
     config: {},

     // `request` is the request that generated this response
     // It is the last ClientRequest instance in node.js (in redirects)
     // and an XMLHttpRequest instance the browser
     request: {}
   }
 */
const getUserProfile = async accessToken => {
  let result = undefined;

  const headers = {
    Authorization: `google-token ${accessToken}`
  };

  try {
    result = await axios.get(endpoints.profile, {
      headers
    });
  } catch (error) {
    console.log(error);

    result = error;
  }

  return result;
};

export default {
  getUserProfile
};
